<template>
    <a :href="path ? `${endPoint}/file?path=${path}` : '#'" class="file flex items-center" :class="{'fileHover': !upload}" @click="$emit('click')">
      <vs-icon icon-pack="far" :icon="`fa-${type}`" />
      <div class="p-3 w-full">
        <template v-if="upload">
          <div class="flex items-center">
            <p class="text-primary max-w-xs truncate">{{name}} </p>
            <small class="text-dark ml-2">({{size | formatBytes}})</small>
            <vs-button class="ml-auto" size="small" @click="$emit('remove')" :disabled="disabled" radius color="dark" type="flat" icon-pack="feather" icon="icon-x"></vs-button>
          </div>
          <vs-progress v-if="progress" color="success" :percent="progress" />
        </template>

        <template v-else>
          <p class="text-primary truncate w-48">{{name}}</p>
          <small class="text-dark"> {{size | formatBytes}} </small>
        </template>

      </div>
      <vs-button v-if="!upload" class="my-auto mr-3" type="flat" size="large" icon-pack="feather" icon="icon-download" />
    </a>
</template>

<script>
    import fileAPI from '@/api/fileAPI'

    export default {
        name: 'file',
        props: {
            name: {
                type: String,
                default: 'untitled.txt'
            },
            size: {
                type: Number,
            },
            extension: {
                type: String,
                default: null
            },
            path: {
                type: String,
                default: null
            },
            upload: {
                type: Boolean,
                default: false
            },
            progress: {
                default: null
            },
            disabled: {
                default: false,
                type: Boolean
            }
        },
        data () {
            return {
                endPoint: process.env.VUE_APP_API_ENDPOINT,
            }
        },
        computed: {
            type() {
                let ext = this.extension ? this.extension : this.name.slice(this.name.lastIndexOf('.')+1, this.name.length).toLowerCase()

                if(ext === 'docx' || ext === 'doc') return 'file-word'
                else if (ext === 'pptx'  || ext === 'ppt') return 'file-powerpoint'
                else if (ext === 'zip' || ext === 'rar') return 'file-archive'
                else if (ext === 'xlsx' || ext === 'xls') return 'file-excel'
                else if (ext === 'pdf') return 'file-pdf'
                else if (['jpg', 'png', 'jpeg'].includes(ext)) return 'file-image'
                else if (['avi', 'flv', 'wmv', 'mov', 'mp4', '3gp'].includes(ext)) return 'file-video'
                else return 'file'
            },
        },
        methods: {
            download(){
                if(this.upload && !this.path) return

                fileAPI.download(this.path, this.name)
                this.$emit('click')
            }
        }
    }
</script>

<style lang="scss" scoped>
  .file {
    position: relative;
    border-radius: .5rem;
    -webkit-box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.1);
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;

      .vs-icon {
        font-size: 2rem;
        border-right: 1px solid #dae1e7;
        padding: 5px 20px;
      }
  }

  .fileHover {
    cursor: pointer;
  }
  .fileHover:hover {
    -webkit-transform: translateY(4px);
    transform: translateY(4px);
    -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  }
</style>
